"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingV1 = void 0;
var TrackingV1 = /** @class */ (function () {
    function TrackingV1(data) {
        this.possibleDetectorProfileTypes = data.possibleDetectorProfileTypes;
        this.vendorToProtocol = data.vendorToProtocol;
        this.possibleSensorProfileTypes = data.possibleSensorProfileTypes;
        this.possibleDetectorLocations = data.possibleDetectorLocations;
        this.detectorTypeToVendor = data.detectorTypeToVendor;
        this.sensorProfileTypeToVendor = data.sensorProfileTypeToVendor;
        this.conditionsForMissing = data.conditionsForMissing;
        this.vendorList = data.vendorList;
    }
    TrackingV1.prototype.getPossibleDetectorProfileTypes = function () {
        return this.possibleDetectorProfileTypes;
    };
    TrackingV1.prototype.getPossibleDetectorLocations = function () {
        return this.possibleDetectorLocations;
    };
    TrackingV1.prototype.getVendorToProtocol = function () {
        return this.vendorToProtocol;
    };
    TrackingV1.prototype.getConditionsForMissing = function () {
        return this.conditionsForMissing;
    };
    TrackingV1.prototype.getPossibleSensorProfileTypes = function () {
        return this.possibleSensorProfileTypes;
    };
    TrackingV1.prototype.getDetectorTypeToVendor = function () {
        return this.detectorTypeToVendor;
    };
    TrackingV1.prototype.getSensorProfileTypeToVendor = function () {
        return this.sensorProfileTypeToVendor;
    };
    TrackingV1.prototype.getVendorList = function () {
        return this.vendorList;
    };
    return TrackingV1;
}());
exports.TrackingV1 = TrackingV1;
//# sourceMappingURL=tracking.js.map